export enum LoginMethodEnum {
  StaffHub = 'StaffHub',
  PCS = "PCS",
}
